module.exports = __webpack_public_path__ + "assets/img/concealtit.c6c02d46.png";